if (!customElements.get('header-account-menu')) {
  customElements.define(
    'header-account-menu',
    class HeaderAccountMenu extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details?.querySelector('summary');
        this.wishlistButton = this.querySelector('[data-account-wishlist]');
        if (!this.details || !this.summary) return;

        this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        this.summary.setAttribute('aria-controls', 'HeaderAccountMenu');

        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.openedByHover) {
            this.openedByHover = false;
            return;
          }
          this.details.open = !this.details.open;
        });
        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        });
        this.addEventListener('mouseenter', () => {
          this.cancelHoverClose();
          if (this.details.open) return;
          this.openedByHover = true;
          this.open();
        });
        this.addEventListener('mouseleave', () => {
          this.scheduleHoverClose();
        });
        this.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.details.open) return;
          this.close();
          this.summary.focus();
        });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        });

        this.wishlistButton?.addEventListener('click', () => {
          const wishlistTitle = document.querySelector('#notepad-anchor-title');
          const wishlistTrigger =
            wishlistTitle?.closest('button, a, [role="button"]') ||
            wishlistTitle ||
            document.querySelector('button.st-wishlist-details-button');

          if (!wishlistTrigger) return;

          wishlistTrigger.click();
          this.close();
        });
      }

      open() {
        this.details.open = true;
      }

      scheduleHoverClose() {
        this.cancelHoverClose();
        this.hoverCloseTimer = window.setTimeout(() => {
          if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
        }, 250);
      }

      cancelHoverClose() {
        if (!this.hoverCloseTimer) return;
        window.clearTimeout(this.hoverCloseTimer);
        this.hoverCloseTimer = null;
      }

      close() {
        this.cancelHoverClose();
        this.openedByHover = false;
        this.details.open = false;
      }
    }
  );
}
